// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__ZcXrW","bgimg":"PageHeader_bgimg__7Fpwg"};